module.exports = __webpack_public_path__ + "img/sign-47.defb6001.jpg";